import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  list({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentList/list`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentList/exportList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findAllAgent({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`agentList/findAllAgent`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findAllCard({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`agentList/findAllCard`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveHairpinResume({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`agentList/saveHairpinResume`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  generateDeptQRCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`agentList/generateDeptQRCode`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  idcardCollect({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`yunBind/idcardCollect`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
